import { useState, useEffect } from "react";

const useCheckForms = (
  dietForms,
  exerciseForms,
  setShowFormModal,
  setModalText
) => {
  const [medicalFormId, setMedicalFormId] = useState(null);
  const [modalLabel, setModalLabel] = useState("");

  useEffect(() => {
    if (exerciseForms && exerciseForms.need_both.length > 0) {
      setShowFormModal(true);
      setMedicalFormId(exerciseForms.need_both[0].id);
      setModalText("لطفا فرم های مربوط به طرح تمرین خود را تکمیل فرمایید");
      setModalLabel("exercise both");
      return;
    }
    if (exerciseForms && exerciseForms.need_medical.length > 0) {
      setShowFormModal(true);
      setMedicalFormId(exerciseForms.need_medical[0].id);
      setModalText(
        "لطفا فرم های مربوط به اطلاعات پزشکی طرح تمرین خود را تکمیل فرمایید"
      );
      setModalLabel("exercise medical");
      return;
    }
    if (exerciseForms && exerciseForms.need_first_month.length > 0) {
      setShowFormModal(true);
      setMedicalFormId(exerciseForms.need_first_month[0].id);
      setModalText(
        "لطفا فرم های مربوط به اطلاعات بدنی طرح تمرین خود را تکمیل فرمایید"
      );
      setModalLabel("exercise first month");
      return;
    }
    if (dietForms && dietForms.need_info) {
      setShowFormModal(true);
      setMedicalFormId(dietForms.id);
      setModalText("لطفا فرم های مربوط به طرح تغذیه خود را تکمیل فرمایید");
      setModalLabel("diet info");
      return;
    }
    if (dietForms && dietForms.need_medical) {
      setShowFormModal(true);
      setMedicalFormId(dietForms.id);
      setModalText(
        "لطفا فرم های مربوط به اطلاعات پزشکی طرح تغذیه خود را تکمیل فرمایید"
      );
      setModalLabel("diet medical");
      return;
    }
    if (dietForms && dietForms.need_first_month) {
      setShowFormModal(true);
      setMedicalFormId(dietForms.id);
      setModalText(
        "لطفا فرم های مربوط به اطلاعات بدنی طرح تغذیه خود را تکمیل فرمایید"
      );
      setModalLabel("diet first month");
      return;
    }
  }, [dietForms, exerciseForms]);

  return { medicalFormId, modalLabel };
};

export default useCheckForms;
